import { client } from "src/services/client";

export const fetchDevelopmentClusters = async (query: string) =>
    client({
        method: "GET",
        url: `/development/map?${query}`,
        headers: { "Content-Type": "application/json" },
    }).then((response) => response.data);
